import {queries} from '@/shared/integrations/zero'
import {useQuery} from '@rocicorp/zero/react'

export function useGetWardUsers(id: string | undefined) {
  return useQuery(queries.locations.getWardUsersById(id || ''))
}
